import {
	SegmentedButtons,
	type SegmentedButtonsProps,
} from "react-native-paper";
import { useAppTheme } from "../useAppTheme";

type Props = SegmentedButtonsProps & {
	showSelectedCheck?: boolean;
};

export const ConnectedButtonGroup = ({
	showSelectedCheck = true,
	...props
}: Props) => {
	const { buttons, value } = props;
	const theme = useAppTheme();

	const selectedValues = Array.isArray(value) ? value : [value];
	const buttonsWithCheck = showSelectedCheck
		? buttons.map((button) => {
				const isSelected = selectedValues.includes(button.value);
				return {
					...button,
					icon: button.icon ?? (isSelected ? "check" : undefined),
					style: [
						button.style,
						{
							backgroundColor: isSelected
								? theme.colors.secondaryContainer
								: theme.colors.surface,
						},
					],
				};
			})
		: buttons;

	return <SegmentedButtons {...props} buttons={buttonsWithCheck} />;
};
